import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createClient,
  deleteClient,
  getClientById,
  getClientLogById,
  getClientList,
  updateClient,
  updateKycStatus,
} from '../../services/ClientService'

interface GetClientListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface ClientState {
  ClientList: any
  ClientLog: any
  client: any
  kycClient: any
}

const initialState: ClientState = {
  ClientList: null,
  ClientLog: null,
  client: null,
  kycClient: null,
}

// Fetch client list
export const getClientListApi = createAsyncThunk(
  'client/getClientList',
  async ({pageNumber, pageSize, filterkey}: GetClientListParams, {rejectWithValue}) => {
    try {
      const result = await getClientList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch client by ID
export const getClientByIdApi = createAsyncThunk(
  'client/getClientById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getClientById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch client Log by ID
export const getClientLogByIdApi = createAsyncThunk(
  'client/getClientLogById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getClientLogById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new client
export const createClientApi = createAsyncThunk(
  'client/createClient',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createClient(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update client
export const updateClientApi = createAsyncThunk(
  'client/updateClient',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateClient(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete client
export const deleteClientApi = createAsyncThunk(
  'client/deleteClient',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteClient(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

export const updateKycStatusApi = createAsyncThunk(
  'client/updateKycStatus',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateKycStatus(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const ClientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getClientListApi.fulfilled, (state, action) => {
        state.ClientList = action.payload
      })
      .addCase(getClientByIdApi.fulfilled, (state, action) => {
        state.client = action.payload
      })
      .addCase(getClientLogByIdApi.fulfilled, (state, action) => {
        state.ClientLog = action.payload
      })
      .addCase(createClientApi.fulfilled, (state, action) => {
        state.client = action.payload
      })
      .addCase(updateClientApi.fulfilled, (state, action) => {
        state.client = action.payload
      })
      .addCase(deleteClientApi.fulfilled, (state, action) => {
        state.client = null // Assuming after deletion you want to clear the client state
        // Alternatively, you could modify the Client if necessary.
      })

      .addCase(updateKycStatusApi.fulfilled, (state, action) => {
        state.kycClient = action.payload // Assuming after deletion you want to clear the client state
        // Alternatively, you could modify the Client if necessary.
      })
  },
})

export default ClientSlice
